import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import PropTypes from 'prop-types';

import Traductor from 'components/Traductor';
import PricesTable from 'components/shared/vehicleCard/Table';
import PriceRow from 'components/rentingRedRac/VehicleDetails/PriceCard';
import ModalWrapper from 'components/rentingRedRac/Modal/Wrapper';
import Button from 'components/bronson/Button';

import RentingService from 'services/RentingService';
import Globals from '../../../Globals';

import { formatDate } from 'Functions';
import { formatNumber } from 'js/components/shared/vehicleFunctions';

import { vehicleTypes } from 'components/rentingRedRac/types';

const RentingRedRacVehicleDetails = ({ onShowDetail, vehicle }) => {
    const t = useMemo(() => new Traductor(), []);
    const [
        {
            [Globals.COOKIES.JWT]: { AccessToken },
        },
    ] = useCookies([Globals.COOKIES.JWT]);
    const [prices, setPrices] = useState();
    const fetchVehiclePrices = useCallback(async () => {
        try {
            const response = await RentingService.getVehiclePrices(
                vehicle.Id.trim(),
                AccessToken
            );
            if (response?.body?.Result) {
                setPrices(response?.body?.Result);
            }
        } catch (error) {
            console.log(error);
        }
    }, [AccessToken, vehicle.Id]);
    useEffect(() => {
        fetchVehiclePrices();
    }, [fetchVehiclePrices]);

    const renderDetailsItem = useCallback(
        (label, content = '--') => (
            <li className="o-layout__item u-1/4 u-1/2@s u-m-none u-p-none u-mb">
                <p className="u-text-disabled">{label}</p>
                <p>{content}</p>
            </li>
        ),
        []
    );

    return (
        <ModalWrapper onShowModal={onShowDetail}>
            <section className="o-layout u-m-none u-mt-large u-mt-none@s">
                <article className="o-layout__item u-m-none u-mb">
                    <header className="o-layout__item u-p-none u-m-none u-mb-large">
                        <h3 className="u-m-none">
                            {t.getTraduction('Details')}
                        </h3>
                    </header>
                    <p className="u-mb-large u-text-bold">
                        {`${vehicle.Plate} - ${vehicle.Model}`}
                    </p>
                    <ul className="u-m-none u-mb-large">
                        {renderDetailsItem(
                            `${t.getTraduction('Date')} ${t
                                .getTraduction(`Expiration`)
                                .toLowerCase()}`,
                            formatDate(vehicle?.ExpirationDate)
                        )}
                        {renderDetailsItem(
                            t.getTraduction(`ComercialProduct`),
                            vehicle?.ProductName
                        )}
                        {renderDetailsItem(
                            t.getTraduction('Gestor'),
                            vehicle?.Manager
                        )}
                        {renderDetailsItem(
                            t.getTraduction('ImportValidityDate'),
                            formatDate(vehicle?.FromDateAmount)
                        )}
                        {renderDetailsItem(
                            t.getTraduction('Installation'),
                            vehicle?.Dealer
                        )}
                        {renderDetailsItem(
                            t.getTraduction('FinancialOperation'),
                            vehicle?.FinancialOperation
                        )}
                        {renderDetailsItem(' ', ' ')}
                        {/* Empty list item asked in design */}
                        {renderDetailsItem(
                            t.getTraduction('MinimumSellingImport'),
                            `${formatNumber(
                                vehicle?.MinimumPrice?.toFixed(2)
                            )}€`
                        )}
                    </ul>
                    <hr />
                </article>
                <article className="o-layout__item u-m-none u-mb-large">
                    <header className="o-layout__item u-p-none u-m-none u-mb-large">
                        <h3 className="u-m-none">
                            {t.getTraduction('VehiclesPriceTable')}
                        </h3>
                    </header>
                    <PricesTable
                        options={{}}
                        loading={false}
                        headers={[
                            t.getTraduction('ValidityDateFrom'),
                            `${t.getTraduction('Import')} (IVA incl.)`,
                            t.getTraduction('OwnerChange'),
                            t.getTraduction('Assurance'),
                            {
                                className: 'u-text-center',
                                text: t.getTraduction('MinimumSellingImport'),
                            },
                        ]}
                        RowComponent={PriceRow}
                        items={prices}
                    />
                </article>
                <Button
                    options={{
                        text: t.getTraduction('Close'),
                        class: 'u-block u-block-center',
                    }}
                    onClick={onShowDetail}
                />
            </section>
        </ModalWrapper>
    );
};

RentingRedRacVehicleDetails.propTypes = {
    onShowDetail: PropTypes.func.isRequired,
    vehicle: vehicleTypes,
};

export default RentingRedRacVehicleDetails;
